<template>
  <div id="cbuyHeader">
    <ul>
      <li :class="{ enable: nowPage === 'cbuyList' }">
        <router-link to="/cbuy/list">購買項目</router-link>
      </li>
      <li :class="{ enable: nowPage === 'cbuyHis' }">
        <router-link to="/cbuy/his">交易明細</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "CbuyHeader",
  props: { nowPage: String },
  computed: {
    ...mapGetters({
      webMode: "webMode",
    }),
    ...mapState({
      menu: (state) => state.website.menu,
    }),
  },
};
</script>
<style scoped>
@import "~@/assets/css/cbuy-header.css";
</style>


